<template>
  <router-view />
  <ConfirmDialog />
  <ToastHost />
</template>

<script>
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue'
import ToastHost from '@/components/ui/ToastHost.vue'

export default {
  name: 'App',
  components: { ConfirmDialog, ToastHost }
}
</script>
